<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Elaboración de Informe de Evaluación In Situ / Remota"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <!-- <button v-if="showOnlyStatus505"
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Procesar
          </button> -->
        </div>
      </div>

      <!-- <div class="col-md-12">
        <app-note
          class="mb-primary"
          title="Observaciones"
          content-type="html"
          v-if="evalTest && evalTest.evaluation_plan_reject_counter > 0"
          :notes="[evalTest.evaluation_plan_observations]"
        />
      </div> -->

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
      <!-- <div class="col-sm-12">
        <br />
        <div class="float-left mb-3 mb-3">
          <div class="form-group text-left">
            <label>¿Existen no conformidades?</label>
            <app-input
              type="radio-buttons"
              v-model="non_conformities"
              :list="confirm"
            />
          </div>
        </div>
      </div> -->
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import * as actions from "../../../apiURL";
import { axiosPatch } from "@/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  props: {
    evalTestId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      tabsHorizontal: [
        // {
        //   icon: "briefcase",
        //   name: "Resumen General",
        //   component: "evaluation-plan-report-general-summary",
        //   permission: "",
        // },
        // {
        //   icon: "briefcase",
        //   name: "Información de la Evaluación",
        //   component: "",
        //   permission: "",
        // },
        // {
        //   icon: "briefcase",
        //   name: "Hallazgos Detectados",
        //   component: "evaluation-plan-report-findings",
        //   permission: "",
        // },
        {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-index",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Informe de Evaluación In Situ / Remota",
          component: "evaluation-plan-report-annexes",
          permission: "",
        },
        // {
        //   icon: "briefcase",
        //   name: "Continuación del Proceso",
        //   component: "",
        //   permission: "",
        // },
        // {
        //   icon: "briefcase",
        //   name: "Alcance",
        //   component: "",
        //   permission: "",
        // },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      showOnlyStatus505:false,
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      non_conformities: null,
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
  },
  watch: {
    evalTest: function () {
      this.non_conformities = this.evalTest.non_conformities;
      // Validar visualizacion vista en estado 505 - 603 - 604
              this.axiosGet(
        `${actions.EVALUATION_PLAN}/report/info/${this.evalTestId}`
      )
        .then((response) => {
            if(response.data.code == 505){
              this.showOnlyStatus505 = true;
            }else{  this.showOnlyStatus505 = false; }
        })
        .catch((error) => {
        });

    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.$store.state.accreditation.currentStatus = 505;
    this.data();
    this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.EVALUATION_PLAN}?tab=Elaboración%20de%20Informe%20de%20Evaluación%20In%20Situ%20/%20Remota`;
    },
    data() {
      this.$store.dispatch("getEvalTest");
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.EVALUATION_PLAN}/report/process?evalTestId=${this.evalTestId}`;
      this.deleteLoader = true;
      axiosPatch(url, { non_conformities: this.non_conformities })
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },

    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.$store.state.evaluatorReview.evalTestId}`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
        });
    },
  },
};
</script>
